module.exports = __webpack_public_path__ + "img/logo-en-botton-dark.efcb3c1.svg";